import { checkImageURL, checkDecimals } from "helpers";

const onchainFormSpec = [
  {
    name: "name",
    label: "代币名称",
    description: "输入你的代币名称，不要超过3个单词",
    type: "text",
    default: "Bitcoin Cash",
    required: true,
    errorMessage: "名称（必填）",
  },
  {
    name: "symbol",
    label: "代币符号",
    description: "输入代币符号",
    type: "text",
    default: "BCH",
    required: true,
    errorMessage: "必填符号",
  },
  {
    name: "decimals",
    label: "精度",
    description: "精度建议不要超过9",
    type: "number",
    validate: checkDecimals,
    default: 9,
    showDefault: true,
    required: true,
    errorMessage: "需要 0 到 9 之间的小数", // https://github.com/ton-blockchain/TEPs/blob/master/text/0064-token-data-standard.md#jetton-metadata-attributes
  },
  {
    name: "mintAmount",
    label: "发行总量",
    description: "成功铸造后会发送带您的发币钱包",
    type: "number",
    default: 21000000,
    required: true,
    errorMessage: "总量必填",
  },
  {
    name: "description",
    label: "代币简介",
    description: "简述您的代币",
    type: "string",
    default: "Low fee peer-to-peer electronic cash alternative to Bitcoin",
  },

  {
    name: "tokenImage",
    label: "Jetton Logo URL",
    description: "填入你的代币LOGO图片地址，或者点击下方上传按钮上传图片",
    type: "string",
    required: false,
    validate: checkImageURL,
    default: "https://bitcoincash-example.github.io/website/logo.png",
  },
];

const offchainFormSpec = [
  {
    name: "offchainUri",
    label: "Offchain URI",
    description: "JSON containing metadata. Don't forget to pin it if it's ipfs",
    type: "string",
    default: "",
    required: true,
    errorMessage: "URI required",
  },
  {
    name: "mintAmount",
    label: "Amount to Mint",
    description: "Number of initial tokens to mint and send to your wallet address (float)",
    type: "number",
    default: 21000000,
    required: true,
    errorMessage: "Mint amount required",
    disabled: undefined,
  },
];

export { onchainFormSpec, offchainFormSpec };
